import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  EditSaveHandler,
  isPageEditFalse,
} from "../CommonComponent/EditSaveHandler";
import {
  SubmitApprovalRequestAction,
  ViewRequestStatusAction,
} from "../../../redux/actions/GlobalAction";
import {
  getPaymentDetailsAction,
  updatePaymentDetailsAction,
} from "../../../redux/actions/PaymentDetailsAction";
import { MandatoryStar } from "../../../Utils/helper";
import Lightbox from "react-awesome-lightbox";
import { ImageUploadRemoveComponent } from "../CommonComponent/ImageUploadRemoveComponent";
import { Formik } from "formik";
import {
  InputFieldComponent,
  InputFieldNumberComponent,
  InputTextFieldComponent,
} from "../CommonComponent/InputFields";
import { YupValidations } from "./helper";
import { getNetworkMenuId, getRole } from "../../../Utils/types";

const PaymentDetails = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const [isImageOpen, setIsImageOpen] = useState(false);
  const [imagePath, setImagePath] = useState("");

  useEffect(() => {
    dispatch(getPaymentDetailsAction());
  }, []);

  const isShowSubmitButton = useSelector(
    (state) => state.PaymentDetailsReducer.getPaymentDetails?.isShowSubmitButton
  );

  const getPaymentDetails = useSelector(
    (state) => state?.PaymentDetailsReducer?.getPaymentDetails?.paymentDetails
  );
  const isPageEdit = useSelector((state) => state?.globalReducer?.isPageEdit);

  const gstCertificate = getPaymentDetails?.images?.filter(
    (ele) => ele.docType === "GST"
  )?.[0];

  const cancelCheque = getPaymentDetails?.images?.filter(
    (ele) => ele.docType === "CANCELCHEQUE"
  )?.[0];

  useEffect(() => {
    if (getPaymentDetails && !isPageEdit) {
      setData(getPaymentDetails);
    }
  }, [getPaymentDetails, isPageEdit]);

  return (
    <Formik
      enableReinitialize={true}
      initialValues={{ ...data }}
      onSubmit={async (values) => {
        const formData = new FormData();
        formData.append("AccountNumber", values?.accountNumber);
        formData.append("AadharNumber", values?.aadharNumber);
        formData.append("GSTRegistrationNumber", values?.gstRegistrationNumber);
        formData.append("BankName", values?.bankName);
        formData.append("BranchName", values?.branchName);
        formData.append("IFSCCode", values?.ifscCode);
        formData.append("PayeeName", values?.payeeName);
        formData.append("BillingName", values?.billingName);
        formData.append("BillingNumber", values?.billingNumber);
        formData.append("panNumber", values?.panNumber);
        await dispatch(updatePaymentDetailsAction(formData));
        await dispatch(getPaymentDetailsAction());
        await isPageEditFalse(dispatch);
        await dispatch(ViewRequestStatusAction("PaymentDetail"));
      }}
      validationSchema={YupValidations}
    >
      {(props) => {
        const { values, errors, handleChange, handleSubmit, setFieldValue } =
          props;
        return (
          <form onSubmit={handleSubmit}>
            <div className="right-section">
              <div className="card payment-details-section">
                <div className="card-body">
                  <div className="payment-header edit-save-css">
                    <h2 style={{ fontSize: "18px" }}>Payment Details</h2>
                    {((getNetworkMenuId()?.canEdit && getRole() === "NetworkAdmin") || getRole() === "ServiceProvider") &&
                      <EditSaveHandler
                        isShowViewButton={isShowSubmitButton}
                        moduleName="PaymentDetail"
                      />}
                  </div>
                  <div className="personal-details">
                    <div className="row gx-5 mt-4">
                      <InputFieldNumberComponent
                        heading={"Account Number"}
                        placeholder="Enter account number"
                        minLength={9}
                        maxLength={18}
                        name={"accountNumber"}
                        handleChange={handleChange}
                        isPageEdit={isPageEdit}
                        values={values.accountNumber}
                        errors={errors.accountNumber}
                        pageType="PaymentPage"
                        required={true}
                      />
                      <InputFieldNumberComponent
                        heading={"Aadhar Number"}
                        placeholder="Enter aadhar number"
                        minLength={12}
                        maxLength={12}
                        name={"aadharNumber"}
                        handleChange={handleChange}
                        isPageEdit={isPageEdit}
                        values={values.aadharNumber}
                        errors={errors.aadharNumber}
                        pageType="PaymentPage"
                        required={true}
                      />
                      <div className="col-md-6 col-lg-4">
                        <div className="mb-4">
                          <label className="form-label mb-3">Pan Card</label>
                          <MandatoryStar />
                          <input
                            name="panNumber"
                            type="text"
                            minLength={10}
                            maxLength={10}
                            placeholder={"Enter pan card"}
                            className="form-control"
                            value={values.panNumber}
                            onChange={(e) =>
                              setFieldValue(
                                "panNumber",
                                e.target.value.toUpperCase()
                              )
                            }
                            disabled={!isPageEdit}
                          />
                          {errors?.panNumber && isPageEdit && (
                            <div className="errorInputMessage">
                              {errors?.panNumber}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6 col-lg-4">
                        <div className="mb-4">
                          <label className="form-label mb-3">
                            GST Registration Number
                          </label>
                          <input
                            name="gstRegistrationNumber"
                            type="text"
                            minLength={15}
                            maxLength={15}
                            placeholder={"Enter gst number"}
                            className="form-control"
                            value={values.gstRegistrationNumber}
                            onChange={(e) =>
                              setFieldValue(
                                "gstRegistrationNumber",
                                e.target.value.toUpperCase()
                              )
                            }
                            disabled={!isPageEdit}
                            onKeyPress={(event) => {
                              const re = /[0-9a-zA-Z]+/g;
                              if (!re.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                          />
                          {errors?.gstRegistrationNumber && isPageEdit && (
                            <div className="errorInputMessage">
                              {errors?.gstRegistrationNumber}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bank-details">
                    <h4 className="mt-5">Bank Details</h4>
                    <div className="row gx-5 mt-4">
                      <InputTextFieldComponent
                        heading={"Bank Name"}
                        placeholder="Enter bank name"
                        name={"bankName"}
                        handleChange={handleChange}
                        isPageEdit={isPageEdit}
                        values={values.bankName}
                        errors={errors.bankName}
                        pageType="PaymentPage"
                        required={true}
                      />
                      <InputFieldComponent
                        heading={"Branch Name"}
                        placeholder="Enter branch name"
                        name={"branchName"}
                        handleChange={handleChange}
                        isPageEdit={isPageEdit}
                        values={values.branchName}
                        errors={errors.branchName}
                        pageType="PaymentPage"
                        required={true}
                      />
                      <div className="col-md-6 col-lg-4">
                        <div className="mb-4">
                          <label className="form-label mb-3">IFSC Code</label>
                          <MandatoryStar />
                          <input
                            name="ifscCode"
                            type="text"
                            minLength={11}
                            maxLength={11}
                            placeholder={"Enter ifsc code"}
                            className="form-control"
                            value={values.ifscCode}
                            onChange={(e) =>
                              setFieldValue(
                                "ifscCode",
                                e.target.value.toUpperCase()
                              )
                            }
                            disabled={!isPageEdit}
                          />
                          {errors?.ifscCode && isPageEdit && (
                            <div className="errorInputMessage">
                              {errors?.ifscCode}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="Billing-details">
                    <h4 className="mt-5">Billing Details</h4>
                    <div className="row gx-5 mb-4">
                      <InputTextFieldComponent
                        heading={"Name on bill"}
                        placeholder="Enter name on bill"
                        name={"billingName"}
                        handleChange={handleChange}
                        isPageEdit={isPageEdit}
                        values={values.billingName}
                        errors={errors.billingName}
                        pageType="PaymentPage"
                        required={false}
                      />
                      <InputFieldNumberComponent
                        heading={"Mobile Number"}
                        placeholder="Enter mobile number"
                        minLength={10}
                        maxLength={10}
                        name={"billingNumber"}
                        handleChange={handleChange}
                        isPageEdit={isPageEdit}
                        values={values.billingNumber}
                        errors={errors.billingNumber}
                        pageType="PaymentPage"
                        required={false}
                      />
                      <InputTextFieldComponent
                        heading={"Payee Name"}
                        placeholder="Enter payee name"
                        name={"payeeName"}
                        handleChange={handleChange}
                        isPageEdit={isPageEdit}
                        values={values.payeeName}
                        errors={errors.payeeName}
                        pageType="PaymentPage"
                        required={false}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <ImageUploadRemoveComponent
                      imageDetails={cancelCheque}
                      heading="Cancelled Cheque"
                      docType={"CANCELCHEQUE"}
                      setIsImageOpen={setIsImageOpen}
                      setImagePath={setImagePath}
                      getPageAPI={getPaymentDetailsAction}
                      required={true}
                    />
                    <ImageUploadRemoveComponent
                      imageDetails={gstCertificate}
                      heading="GST Certificate"
                      docType={"GST"}
                      setIsImageOpen={setIsImageOpen}
                      setImagePath={setImagePath}
                      getPageAPI={getPaymentDetailsAction}
                      required={false}
                    />
                  </div>
                  <div className="mt-4 mb-2 text-end">
                    {isShowSubmitButton && !isPageEdit && (
                      <button
                        className="btn btn-primary"
                        type="button"
                        onClick={async () => {
                          await dispatch(
                            SubmitApprovalRequestAction("PaymentDetail")
                          );
                          await dispatch(getPaymentDetailsAction());
                          await dispatch(
                            ViewRequestStatusAction("PaymentDetail")
                          );
                        }}
                      >
                        SUBMIT
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {isImageOpen === true && (
              <Lightbox
                image={imagePath}
                title="Image Description"
                onClose={() => setIsImageOpen(false)}
              />
            )}
          </form>
        );
      }}
    </Formik>
  );
};

export default PaymentDetails;
